/**
 * Inline feedback below an email input when validation is managed by the parent.
 */
const EmailFieldFeedback = ({ touched, error, value, showSuccess = true }) => {
  const hasError = touched && error;
  const isValid = touched && !error && value?.trim();

  if (hasError) {
    return <p className="text-red-500 text-sm mt-1">{error}</p>;
  }

  if (showSuccess && isValid) {
    return <p className="text-green-600 text-sm mt-1">✓ Email is valid</p>;
  }

  return null;
};

export default EmailFieldFeedback;
